import React from 'react';
import { Animated, Platform, StyleSheet, View } from 'react-native';

import { useColors } from '../../hooks';
import { useSafeState } from '../../hooks/use-safe-state';
import { SoundProvider } from '../../hooks/use-sound-context';
import maxContainerWidthStyle from '../../styles/max-container-width/max-container-width.style';
import { AudioPlayerWithContext } from '../audio-player/audio-player-with-context';
import type { AudioPlayerWithProviderProps } from '../audio-player/audio-player-with-provider';

interface StickAudioPlayerProps extends AudioPlayerWithProviderProps {
  scrollY: Animated.Value;
}

export function StickAudioPlayer({
  url,
  scrollY,
  ...props
}: StickAudioPlayerProps) {
  const [topHeight, setTopHeight] = useSafeState(0);
  const colors = useColors();

  return (
    <Animated.View
      onLayout={(e) => setTopHeight(e.nativeEvent.layout.y)}
      style={[
        styles.container,
        { backgroundColor: colors.primary },
        Platform.select({
          web: webStickyStyle,
          default: {
            transform: [
              {
                translateY: scrollY.interpolate({
                  inputRange: [topHeight - 1, topHeight, topHeight + 1],
                  outputRange: [0, 0, 1],
                }),
              },
            ],
          },
        }),
      ]}
    >
      <View style={styles.innerContainer}>
        <SoundProvider url={url}>
          <AudioPlayerWithContext {...props} />
        </SoundProvider>
      </View>
    </Animated.View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingBottom: Platform.select({
      web: 20,
      default: 8,
    }),
    zIndex: 9,
  },
  innerContainer: {
    ...maxContainerWidthStyle,
    paddingHorizontal: 15,
  },
});

// Position sticky is supported in web but not on mobile, so the typings aren't there
// and we have to use @ts-ignore to remove the lint error
// @ts-ignore
const webStickyStyle: StyleProp<ViewStyle> = {
  position: 'sticky',
  top: 0,
};
